<nz-rate
  ngDefaultControl
  #firstnameControl="ngModel"
  [name]="config.name"
  [(ngModel)]="config.value"
  nzAllowHalf
  [nzDisabled]="config.disabled"
></nz-rate>
